import { RootState } from 'duck/store'
import { connect } from 'react-redux'

import { updateSearch } from '../../duck/actions'
import { getSearchParams } from '../../duck/selectors'
import PeopleTextFilter, { PeopleTextFilterProps } from './PeopleTextFilter.presentational'

const mapStateToProps = (state: RootState): StateProps => {
  const { search } = getSearchParams(state)
  return {
    search,
  }
}

type StateProps = Omit<PeopleTextFilterProps, 'onChangeSearch'>

const mapDispatchToProps = {
  onChangeSearch: updateSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(PeopleTextFilter)
